export const pageSizes = [5, 10, 20, 50, 100];
